module.exports = __webpack_public_path__ + "static/media/1-6-1.7256d8de.png";